import styled, { css } from "styled-components";
import { IStyledComponentList } from "./interface";

const Container = styled.ul<IStyledComponentList>`
    display: flex;
    width: 100%;
    flex-direction: column;
    transition: 150ms ease;


    li.list-component-child{
        display: flex;
        justify-content: space-between;
        flex-direction: row;
        flex-wrap: wrap;
        position: relative;

        align-items: center;

        border-radius: 20px;
        border: 1px solid var(--border-color);
        box-shadow: 0 2px 1px -1px var(--border-color);
        background: var(--card-background);
        color: var(--default-color-font);

        font-size: 0.83rem;

        padding: 4px;
        margin: 5px 0;

        transition: 150ms ease;


        @media(max-width: 599px){
            flex-direction: column;
            flex-wrap: nowrap;
        }

        &.is-children{
            margin-bottom: 0.5rem;
            padding: 0;
            padding-left: 4px;
            border-bottom: none;
        }
    }

    li.list-component-header{
        display: flex;
        justify-content: space-between;
        flex-direction: row;
        flex-wrap: wrap;

        border-bottom: 1px solid var(--border-color);

        font-size: 0.9rem;

        padding: 4px;
        margin: 5px 0;

        position: sticky;
        top: 0;
        background: var(--input-background-color);
        color: var(--default-color-font);
        z-index: 2;
    }
    
    &:hover{
        li.list-component-child{
            box-shadow: none;
            &:hover{
                box-shadow: rgba(0, 0, 0, 0.12) 0px 3px 8px;
            }
        }
    }
    
    ${(props) => props.layout === "table" && css`
        li.list-component-header{
            border-top: 1px solid var(--border-color);
            border-bottom: 1px solid var(--border-color);
            background: var(--li-header-color);
        }
        li.list-component-child{
            margin: 0;
            padding: 4px;
            border: none;
            border-radius: 0;
            border-bottom: 1px solid var(--border-color);
            background-color: var(--li-child-striped);
            &:nth-child(odd){
                background-color: var(--li-child-color);
            }
        }
    `}

    @media print{
        li{
            flex-direction: row !important;
            font-size: 8px !important;
            background-color: #FFF !important;
            color: #474555 !important;
            min-height:unset !important;
            max-height:unset !important;
        }
    }

    ${(props) => props.styleInline}
`;

interface IStyledSpan{
    truncate?: boolean;
    bold?: boolean;
}

export const StyledSpan = styled.span<IStyledSpan>`
    ${(props) => props.bold && css`
        font-weight: bold;
    `}
    
    ${(props) => props.truncate && css`
        text-overflow: ellipsis;
        flex-wrap: nowrap;
        overflow: hidden;
    `}
`;

export const maxWidthXs = css`
    @media(max-width: 599px){
        justify-content: flex-start !important;
    }
`;

export const HiddeDiv = styled.div`
    display: none; 
    visibility: hidden;
`;

export const CleanHeader  = css`
    li.list-component-header{
        border-top: 1px solid var(--input-background-color);
        border-bottom: 1px solid var(--border-color);
        background: var(--input-background-color);
    }	
`;

export default Container;
